import {FC} from 'react'
import {ColumnInstance} from 'react-table'
import { EventType } from './_columns_1'

type Props = {
  column: ColumnInstance<EventType>
}

const CustomHeaderColumn: FC<Props> = ({column}) => (
  <>
    {column.Header && typeof column.Header === 'string' ? (
      <th {...column.getHeaderProps()}>{column.render('Header')}</th>
    ) : (
      column.render('Header')
    )}
  </>
)

export {CustomHeaderColumn}
